import React, {  } from 'react';
import {
    Box,
    Typography,
} from '@mui/material';
import { useStoreState } from 'easy-peasy';

const NoteText = (props) => {
	const brandingData = useStoreState((state) => state?.paCheck?.brandingData);

	const createMarkup = (data) => {
		let markup = (data ? data : '');
		return { __html: markup };
	}
	return (
		<>
			{brandingData?.config_text?.notes_section && (         
				<Box
					sx={{
						backgroundColor: "#f7f7f7",
						borderRadius: "8px",
						padding: "20px",
						marginTop: "20px",
						border: "1px solid #e0e0e0",
						width: '100%',
						float: 'left',
					}}
				>
					<Typography variant="h6" fontWeight="bold" gutterBottom>
						Please note:
					</Typography>
					<div dangerouslySetInnerHTML={createMarkup(brandingData?.config_text?.notes_section)}></div>
				</Box>
			)}
		</>
	)
}

export default NoteText;